import React, { useState, useEffect, useContext } from 'react';
import '../App.css';
import axios from 'axios';
import Sidebar from '../componenteExtra/SidebarLider';
import { GrupoContext } from '../GrupoContext';
import SessionManager from '../componenteExtra/SessionManager';
import * as XLSX from 'xlsx';

const SolicitudesAsignadas = () => {
    const { grupo, setGrupo } = useContext(GrupoContext);
    const [activities, setActivities] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedFilial, setSelectedFilial] = useState("");

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        const savedGrupo = localStorage.getItem('grupo');
        if (savedGrupo) {
            setGrupo(savedGrupo);
        }
    }, [setGrupo]);

    useEffect(() => {
        if (grupo) {
            localStorage.setItem('grupo', grupo);

            axios.get(`${process.env.REACT_APP_BACKEND_URL}/assigned_requests/${grupo}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then(response => {
                    setActivities(response.data);
                })
                .catch(error => console.error('Error fetching data: ', error));
        }
    }, [grupo]);

    const filteredActivities = activities.filter(activity =>
        activity.razon_social.toLowerCase().includes(searchTerm.toLowerCase()) &&
        (selectedFilial === "" || activity.filial === selectedFilial)
    );

    const uniqueFiliales = [...new Set(activities.map(activity => activity.filial))];

    const totalActividades = filteredActivities.length;

    const handleDownloadExcel = () => {
        const data = filteredActivities.map(a => ({
            'Código de Proyecto': a.codigo_proyecto,
            'Razón Social': a.razon_social,
            'Filial': a.filial,
            'Solicitante': a.nombre_solicitante,
            'Tipo de trabajo': a.tipo_solicitud,
            'Regulación': a.tipo_regulacion,
            'Socio de auditoría': a.encargado_auditoria,
            'Rubro GET': a.rubro_get,
            'Nombre Actividad GET': a.nombre_actividad_get,
            'Jefe de Grupo': a.jefe_grupo,
            'Subrogante': a.subrogante,
            'Fecha de emisión final': a.fecha_emision || '',
            'Fecha de Entrega de Información': a.fecha_entrega_informacion || '',
            'Fecha Inicio': a.fecha_de_inicio || '',
            'Fecha Termino': a.fecha_de_termino || '',
            'Documentación': a.enlace_comentario || '',
            'Staff Asignado': a.staff_asignado || '',
            'Correo Staff': a.correo || '',
            'Fecha Inicio Trabajo Staff': a.fecha_inicio_trabajo_staff || '',
            'Horas Estándar': a.horas_estandar || '',
            'Estado Staff': a.estados_staff || ''
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Solicitudes');
        XLSX.writeFile(wb, `SolicitudesAsignadas_Grupo_${grupo}.xlsx`);
    };

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel" style={{ position: 'relative' }}>
                    <h1>Solicitudes asignadas - grupo {grupo}</h1>
                    <h2>Total Actividades: {totalActividades}</h2>

                    {/* BOTÓN REPORTE ARRIBA A LA DERECHA */}
                    <button
                        onClick={handleDownloadExcel}
                        disabled={totalActividades === 0}
                        style={{
                            position: 'absolute',
                            top: '50px',
                            right: '15px',
                            backgroundColor: totalActividades === 0 ? '#6c757d' : '#28a745',
                            color: 'white',
                            border: 'none',
                            padding: '20px 16px',
                            borderRadius: '6px',
                            cursor: totalActividades === 0 ? 'not-allowed' : 'pointer',
                            fontSize: '0.95rem',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
                            zIndex: 10,
                            opacity: totalActividades === 0 ? 0.65 : 1,
                        }}
                        onMouseDown={(e) => {
                            if (totalActividades === 0) return;
                            e.currentTarget.style.transform = 'scale(0.96)';
                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.2)';
                        }}
                        onMouseUp={(e) => {
                            if (totalActividades === 0) return;
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.15)';
                        }}
                    >
                        <svg width="15" height="15" viewBox="0 0 384 512" fill="white" xmlns="http://www.w3.org/2000/svg">
                            <path d="M48 448V64c0-35.3 28.7-64 64-64H224v96c0 35.3 28.7 64 64 64h96v288c0 35.3-28.7 64-64 64H112c-35.3 0-64-28.7-64-64zm96-80l64 64 64-64H304l-80 80 80 80H208l-64-64-64 64H48l80-80-80-80H144z"/>
                        </svg>
                        Reporte
                    </button>

                    <div className="filter-section">
                        <label htmlFor="searchTerm">Filtros - Razón social: </label>
                        <input
                            type="text"
                            id="searchTerm"
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                        />

                        <label htmlFor="filialFilter">Filial: </label>
                        <select
                            id="filialFilter"
                            value={selectedFilial}
                            onChange={e => setSelectedFilial(e.target.value)}
                        >
                            <option value="">Todas</option>
                            {uniqueFiliales.map((filial, index) => (
                                <option key={index} value={filial}>{filial}</option>
                            ))}
                        </select>
                    </div>

                    <div className="activities-table-container">
                        <table className="activities-table">
                            <thead>
                                <tr>
                                    <th>Código de Proyecto</th>
                                    <th>Razón Social</th>
                                    <th>Filial</th>
                                    <th>Solicitante</th>
                                    <th>Tipo de trabajo</th>
                                    <th>Regulación</th>
                                    <th>Socio de auditoría</th>
                                    <th>Rubro GET</th>
                                    <th>Nombre Actividad GET</th>
                                    <th>Jefe de Grupo</th>
                                    <th>Subrogante</th>
                                    <th>Fecha de emisión final</th>
                                    <th>Fecha de Entrega de Información</th>
                                    <th>Fecha Inicio</th>
                                    <th>Fecha Termino</th>
                                    <th>Documentación</th>
                                    <th>Staff Asignado</th>
                                    <th>Correo Staff</th>
                                    <th>Fecha Inicio Trabajo Staff</th>
                                    <th>Horas Estándar</th>
                                    <th>Estado Staff</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredActivities.map((activity, index) => (
                                    <tr key={index}>
                                        <td>{activity.codigo_proyecto}</td>
                                        <td>{activity.razon_social}</td>
                                        <td>{activity.filial}</td>
                                        <td>{activity.nombre_solicitante}</td>
                                        <td>{activity.tipo_solicitud}</td>
                                        <td>{activity.tipo_regulacion}</td>
                                        <td>{activity.encargado_auditoria}</td>
                                        <td>{activity.rubro_get}</td>
                                        <td>{activity.nombre_actividad_get}</td>
                                        <td>{activity.jefe_grupo}</td>
                                        <td>{activity.subrogante}</td>
                                        <td>{activity.fecha_emision || ''}</td>
                                        <td>{activity.fecha_entrega_informacion || ''}</td>
                                        <td>{activity.fecha_de_inicio || ''}</td>
                                        <td>{activity.fecha_de_termino || ''}</td>
                                        <td>
                                            {activity.enlace_comentario ? (
                                                <a href={activity.enlace_comentario} target="_blank" rel="noopener noreferrer" style={{ color: "#0066cc", textDecoration: "underline" }}>
                                                    Ver Documentación
                                                </a>
                                            ) : "-"}
                                        </td>
                                        <td>{activity.staff_asignado || ''}</td>
                                        <td>{activity.correo || ''}</td>
                                        <td>{activity.fecha_inicio_trabajo_staff}</td>
                                        <td>{activity.horas_estandar || ''}</td>
                                        <td>{activity.estados_staff || ''}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SolicitudesAsignadas;